<template>
    <div class="ui-lounge-products-list" data-test="ui-lounge-products-list" :style="sectionStyle">
        <div class="section-container">
            <div class="content-card">
                <Component
                    :is="product.component"
                    v-for="product in blok.items"
                    :key="product._uid"
                    :blok="product"
                    class="product-item"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { ILoungeProductsList } from '@nuxt-monorepo/ui/types/components/ProductSections/LoungeProductsList';

const props = defineProps<{
    blok: ILoungeProductsList;
}>();

const sectionStyle = computed(() => {
    return {
        marginTop: props.blok.marginTop ? `${props.blok.marginTop}px` : null,
        marginBottom: props.blok.marginBottom ? `${props.blok.marginBottom}px` : null,
    };
});
</script>

<style lang="postcss" scoped>
.section-container {
    @apply container mx-auto px-4;
    max-width: 1300px;
}
.content-card {
    @apply lg:pt-[30px] px-1 md:px-[14px] lg:px-4 pb-[38px] bg-white;
    @media screen(lg) {
        box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.37);
    }
}
.product-item {
    @apply mb-4 w-full;
    &:last-child {
        @apply mb-0;
    }
}
</style>
